export class Environments {
    public static dev = 'dev';
    public static local = 'local';
    public static stg = 'stg';
    public static prod = 'prod';
  }
  